import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from '../config';

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.baseUrl,
  }),
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (credentials) => ({
        method: 'POST',
        url: `/users/signin`,
        body: credentials,
      }),
    }),
    signUp: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: `/users/signup`,
        body: data,
      }),
    }),
    generateOTP: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: `/users/generate-otp`,
        body: data,
      }),
    }),
    getOTP: builder.mutation({
      query: (data) => ({
        method: 'GET',
        url: `/users/get-otp`,
        body: data,
      }),
    }),
    confirmOTP: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: `/users/confirm-otp`,
        body: data,
      }),
    }),

    getPosts: builder.query({
      query: () => `posts`,
    }),
  }),
});

export default userApi;

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSignInQuery, useSignUpQuery, useGetPostsQuery } = userApi;
